import { IIconProps, MessageBarType } from '@fluentui/react';
import { Failure } from '../../models/common';
import { UnionMap } from '../../types/union-map';
import { ErrorBannerActionProps } from './error-banner-actions';
import { MessageBannerActionProps } from './message-banner-actions';

export interface ResourceCardError {
    message: React.ReactNode;
    failure?: Failure;
    retryable?: boolean;
    severity: ResourceCardErrorSeverity;
    iconProps?: IIconProps;
}

export type ResourceCardErrorSeverity = 'High' | 'Med' | 'Low';

export const ResourceCardErrorSeverity: UnionMap<ResourceCardErrorSeverity> = {
    High: 'High',
    Med: 'Med',
    Low: 'Low',
};

export type ResourceCardBannerKind = 'Error' | 'Info';

export const ResourceCardBannerKind: UnionMap<ResourceCardBannerKind> = {
    Error: 'Error',
    Info: 'Info',
};

export type ResourceCardBannerViewModel = ResourceCardErrorBannerViewModel | ResourceCardInfoBannerViewModel;

export interface ResourceCardErrorBannerViewModel {
    kind: ResourceCardBannerKind;
    error: ResourceCardError;
    isDismissable: boolean;
    additionalErrorBannerActions?: ErrorBannerActionProps[];
    onRetryFailedOperation?: () => void;
    onSeeErrorDetails?: () => void;
    onDismiss?: () => void;
}

export interface ResourceCardInfoBannerViewModel {
    kind: ResourceCardBannerKind;
    isDismissable: boolean;
    bannerMessage: JSX.Element;
    onDismiss?: () => void;
    onSeeDetails?: () => void;
    iconProps?: IIconProps;
    messageBarType: MessageBarType;
    additionalMessageBannerActions?: MessageBannerActionProps[];
}

/**
 * Type guards
 */

export const isErrorBannerViewModel = (
    viewModel: ResourceCardBannerViewModel
): viewModel is ResourceCardErrorBannerViewModel => viewModel.kind === ResourceCardBannerKind.Error;

export const isInfoBannerViewModel = (
    viewModel: ResourceCardBannerViewModel
): viewModel is ResourceCardInfoBannerViewModel => viewModel.kind === ResourceCardBannerKind.Info;
